import styled from "styled-components";
import { PageBox } from "../../../styles/page";

export const MemberTable = styled(PageBox)`
  border: 0.71px solid #d9d9d9;
  border-radius: 14.26px;
  padding: 30px 20px;
  height: 700px;

  > .list-wrapper {
    display: flex;
    flex-direction: column;
    gap: 7px;
    width: 100%;
    height: 464px;
  }
`;

export const MemberListItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 40px;
  padding: 5px 20px;
  box-sizing: border-box;
  border-radius: 13.94px;
  background: #ecf0f3;
  cursor: pointer;

  > .item {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Pretendard;
    font-size: 11px;
    font-weight: 500;
    text-align: center;
  }

  > .item.z {
    width: 8%;
  }
  > .item.a {
    width: 25%;
    > span {
      padding: 7px 14px;
      border-radius: 9.27px;
      background: #373636;
      color: #fff;
      min-width: 100px;
      text-align: center;
      box-sizing: border-box;
    }
  }
  > .item.b {
    width: 20%;
  }
  > .item.c {
    width: 18%;
  }
  > .item.e {
    width: 12%;
  }
  > .item.g {
    width: 18%;
    display: flex;
    gap: 7px;

    > img {
      width: 15px;
      height: 15px;
      cursor: pointer;
    }
  }
  > .item.h {
    width: 10%;
  }
`;

export const MemberListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 22px;
  border-bottom: 1.54px solid #d9d9d9;

  > .right {
    display: flex;
    align-items: center;
    gap: 10px;

    > .button {
      border-radius: 11.451px;
      background: #bebebe;
      display: flex;
      width: 90px;
      height: 35px;
      justify-content: center;
      align-items: center;
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 11.451px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      cursor: pointer;
    }
  }
`;

export const MemberSearchBox = styled.div`
  display: flex;
  width: 220px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 15px;
  background-color: #fff;
  padding: 3px 15px;
  box-sizing: border-box;

  > input {
    flex: 1;
    border: none;
    outline: none;
    font-family: Pretendard;
    font-size: 12px;
    font-weight: 600;
  }

  input::placeholder {
    color: #b7b7b7;
  }

  .searchIcon {
    width: 40px;
    height: 40px;
    cursor: pointer;
    text-align: right;
    line-height: 40px;
  }
`;

export const MemberTableHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 20px;
  padding-bottom: 15px;
  box-sizing: border-box;

  > .item {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #121212;
    font-family: Pretendard;
    font-size: 11px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: center;
    gap: 5px;

    &.sortable {
      cursor: pointer;
      user-select: none;
      transition: background-color 0.2s;

      &:hover {
        opacity: 0.7;
      }

      > span {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }

      > .sort-arrows {
        display: flex;
        flex-direction: column;
        gap: 1px;
        margin-left: 3px;

        > img {
          width: 8px;
          height: 8px;
          opacity: 0.3;
          transition: opacity 0.2s;

          &.active {
            opacity: 1;
          }

          &.arrow-up {
            transform: rotate(180deg);
          }

          &.arrow-down {
            transform: rotate(0deg);
          }
        }
      }
    }
  }

  > .item.z {
    width: 8%;
  }
  > .item.a {
    width: 25%;
  }
  > .item.b {
    width: 20%;
  }
  > .item.c {
    width: 18%;
  }
  > .item.e {
    width: 12%;
    display: flex;
    gap: 2px;
    position: relative;

    > img {
      cursor: pointer;
    }
  }
  > .item.g {
    width: 18%;
  }

  > .item.h {
    width: 10%;
  }
`;

export const MemberTableInfo = styled.div`
  position: absolute;
  width: 255px;
  box-sizing: border-box;
  background: #fff;
  height: 36px;
  top: 20px;
  left: 35px;
  padding: 10px;
  gap: 20px;
  border-radius: 10px;
  border: 0.93px;
  border: 0.93px solid #d9d9d9;
  box-shadow: 0px 3.71px 3.71px 0px #00000040;
  font-family: Pretendard;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
`;
